<section class="main-content wrapper content-padding " style="margin-top: 50px;">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">Valet</a>
      </label>
    </div>

    <div class="item nowrap">
      <span class="btn-container top-button-container">
        <button class="btn btn-white vertical align-items-center" routerLink="/expert/nuovo">
          Aggiungi Valet<i class="ml-10 fas fa-plus"></i>
        </button>
      </span>
    </div>

    <hr class="gold-hr">

    <section class="main-content wrapper scroll-delivery">
      <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
      <div class="custom-data-output has-margin-top" role="table" id="elencoConsegneExpert">
        <form class="table-row-container row first-row filter" [formGroup]="_expertFilterForm" (ngSubmit)="filter()"
          *ngIf="_expertFilterForm">
          <div class="item data-col-10">
            <h4 *ngIf="isTeamLeader" class="title">Id</h4>
            <h4 class="title" (click)="navigateOrder('Expert.id')" *ngIf="!isTeamLeader">
              <i class="sort-icon fas" [ngClass]="orderIcon('Expert.id')"></i>
              ID</h4>
            <span class="data" *ngIf="!isTeamLeader">
              <input type="text" formControlName="Expert.id">
            </span>
          </div>
          <div class="item data-col-15">
            <h4 class="title" (click)="navigateOrder('User.surname')">
              <i class="sort-icon fas" [ngClass]="orderIcon('User.surname')"></i>
              Cognome</h4>
            <span class="data">
              <input type="text" formControlName="User.surname">
            </span>
          </div>
          <div class="item data-col-15 expertClass">
            <h4 class="title" (click)="navigateOrder('User.name')">
              <i class="sort-icon fas" [ngClass]="orderIcon('User.name')"></i>
              Nome</h4>
            <span class="data">
              <input type="text" formControlName="User.name">
            </span>
          </div>
          <div class="item data-col-15 center expertClass">
            <h4 class="title" (click)="navigateOrder('User.email')">
              <i class="sort-icon fas" [ngClass]="orderIcon('User.email')"></i>
              Email</h4>
            <span class="data">
              <input type="text" formControlName="User.email">
            </span>
          </div>
          <div class="item data-col-10 center expertClass">
            <h4 class="title" (click)="navigateOrder('Expert.phone')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Expert.phone')"></i>
              Telefono</h4>
            <span class="data">
              <input type="text" formControlName="Expert.phone">
            </span>
          </div>
          <div class="item data-col-10 center">
            <h4 class="title" (click)="navigateOrder('Expert.city')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Expert.city')"></i>
              Città</h4>
            <span class="data">
              <input type="text" formControlName="Expert.city">
            </span>
          </div>
          <div class="item data-col-10">
            <h4 class="title" (click)="navigateOrder('Vehicle.name')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Vehicle.name')"></i>
              Mezzo</h4>
            <span class="data">
              <select formControlName="Vehicle.id">
                <option value="">Tutti</option>
                <option *ngFor="let vehicle of vehicles" [value]="vehicle.id">
                  {{vehicle.name}}
                </option>
              </select>
            </span>
          </div>

          <div class="item data-col-15 center">
            <h4 class="title">
              Team Leader
            </h4>
            <span class="data">
              <select formControlName="Expert.isTeamLeader">
                <option value="">Tutti</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </span>
          </div>

          <div class="item data-col-15 center">
            <h4 class="title">
              <i class="sort-icon fas"></i>
              Attivo</h4>
            <span class="data">
              <select formControlName="User.active">
                <option value="">Tutti</option>
                <option value="1">Attivo</option>
                <option value="-1">Disattivo</option>
              </select>
            </span>
          </div>

          <div class="item nowrap">
            <h4 class="title hide-on-mobile">AZIONI</h4>
            <span class="data-row-left btn-container btn-container-actions">
              <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                RICERCA <i class="fas fa-search"></i></button>
                <br/>
              <button class="btn vertical align-items-center" (click)="resetFilter();">
                RESET <i class="fas fa-times-circle"></i></button>
            </span>
          </div>
        </form>

        <div class="table-row-container row" *ngFor="let expert of experts; let i = index">
          <div class="item data-col-10" *ngIf="isTeamLeader">
            <h4 class="title">
              <i class="sort-icon fas"></i>
              ID</h4>
            <span class="data data-id"><a [routerLink]="['/expert', expert.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader) )}">{{ i+1 }}</a></span>
          </div>
          <div class="item data-col-10" *ngIf="!isTeamLeader">
            <h4 class="title" (click)="navigateOrder('Expert.id')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Expert.id')"></i>
              ID</h4>
            <span class="data data-id"><a [routerLink]="['/expert', expert.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader) )}">{{expert.id}}</a></span>
          </div>
          <div class="item data-col-15">
            <h4 class="title" (click)="navigateOrder('User.surname')">
              <i class="sort-icon fas" [ngClass]="orderIcon('User.surname')"></i>
              Cognome</h4>
            <span class="data"><a [routerLink]="['/expert', expert.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader))}">{{expert.user?.surname}}</a></span>
          </div>
          <div class="item data-col-15">
            <h4 class="title" (click)="navigateOrder('User.name')">
              <i class="sort-icon fas" [ngClass]="orderIcon('User.name')"></i>
              Nome</h4>
            <span class="data"><a [routerLink]="['/expert', expert.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader))}">{{expert.user?.name}}</a></span>
          </div>
          <div class="item data-col-15 center">
            <h4 class="title" (click)="navigateOrder('User.email')">
              <i class="sort-icon fas" [ngClass]="orderIcon('User.email')"></i>
              Email</h4>
            <span class="data"><a [routerLink]="['/expert', expert.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader))}">{{expert.user?.email}}</a></span>
          </div>
          <div class="item data-col-10 center">
            <h4 class="title" (click)="navigateOrder('Expert.phone')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Expert.phone')"></i>
              Telefono</h4>
            <span class="data"><a [routerLink]="['/expert', expert.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader))}">{{expert?.phone || "N/A"}}</a></span>
          </div>
          <div class="item data-col-10 center">
            <h4 class="title" (click)="navigateOrder('Expert.city')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Expert.city')"></i>
              Città</h4>
            <span class="data"><a [routerLink]="['/expert', expert.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader))}">{{expert.city || "N/A"}}</a></span>
          </div>
          <div class="item data-col-10">
            <h4 class="title" (click)="navigateOrder('Vehicle.name')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Vehicle.name')"></i>
              Mezzo</h4>
            <span class="data"><a [routerLink]="['/expert', expert.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader))}">{{expert.vehicles.length > 0 ? (getVehicleNames(expert.vehicles) | arrayJoin:", ") : "N/A" }}</a></span>
          </div>

          <div class="item data-col-10 center">
            <h4 class="title">
              Team Leader
            </h4>
            <span class="data">
              <a [routerLink]="['/expert', expert.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader))}">{{ expert.isTeamLeader ? "Yes" : "No" }}</a>
            </span>
          </div>

          <div class="item data-col-10 center active">
            <h4 class="title">
              Attivo
            </h4>
            <span class="data">
              {{translateActive(expert.user?.active)}}
            </span>
          </div>

          <div class="item nowrap">
            <span class="data-row-left btn-container btn-container-actions">

              <button class="btn vertical align-items-center" [routerLink]="['/expert', expert.id, 'availability']" *ngIf="groups.includes('admin')">
                Vecchia Disponibilità
              </button>

              <button class="btn vertical align-items-center" [routerLink]="['/expert', 'availability', expert.id]" *ngIf="groups.includes('admin')">
                Disponibilità
              </button>

              <button class="btn vertical align-items-center" [routerLink]="['/expert', expert.id, 'edit']" *ngIf="groups.includes('admin') || groups.includes('operation')">
                Modifica
              </button>

              <button class="btn vertical align-items-center" [routerLink]="['/expert/payments']" [queryParams]="{ expertId: expert.id }" *ngIf="(groups.includes('admin') || groups.includes('operation')) && expert.user.active === 1">
                Pagamenti
              </button>

              <button class="btn btn-red vertical align-items-center" (click)="$event.preventDefault(); delete(expert.id)" *ngIf="groups.includes('admin')">
                Elimina<i class="ml-10 far fa-trash-alt"></i>
              </button>

            </span>
          </div>
        </div>
      </div>
    </section>
  </div>
</section>

<!--
<section class="title-bar content-padding first-item ">
  <div class="wrapper nowrap">
    <h2 class="title-heading">Valet</h2>
    <div class="item nowrap">
      <span class="data-row-left btn-container top-button-container">
        <button class="btn btn-white vertical align-items-center" routerLink="/expert/nuovo">
          Aggiungi Valet<i class="ml-30 fas fa-plus"></i>
        </button>
      </span>
    </div>
  </div>
</section>

<section class="main-content wrapper content-padding scroll-delivery">
  <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)">
  </app-pagination>
  <div class="custom-data-output has-margin-top" role="table" id="elencoConsegneExpert">
    <form class="table-row-container row first-row filter" [formGroup]="_expertFilterForm" (ngSubmit)="filter()"
      *ngIf="_expertFilterForm">
      <div class="item data-col-10">
        <h4 *ngIf="isTeamLeader" class="title">Id</h4>
        <h4 class="title" (click)="navigateOrder('Expert.id')" *ngIf="!isTeamLeader">
          <i class="sort-icon fas" [ngClass]="orderIcon('Expert.id')"></i>
          ID</h4>
        <span class="data" *ngIf="!isTeamLeader">
          <input type="text" formControlName="Expert.id">
        </span>
      </div>
      <div class="item data-col-15">
        <h4 class="title" (click)="navigateOrder('User.surname')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.surname')"></i>
          Cognome</h4>
        <span class="data">
          <input type="text" formControlName="User.surname">
        </span>
      </div>
      <div class="item data-col-15 expertClass">
        <h4 class="title" (click)="navigateOrder('User.name')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.name')"></i>
          Nome</h4>
        <span class="data">
          <input type="text" formControlName="User.name">
        </span>
      </div>
      <div class="item data-col-15 center expertClass">
        <h4 class="title" (click)="navigateOrder('User.email')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.email')"></i>
          Email</h4>
        <span class="data">
          <input type="text" formControlName="User.email">
        </span>
      </div>
      <div class="item data-col-10 center expertClass">
        <h4 class="title" (click)="navigateOrder('Expert.phone')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Expert.phone')"></i>
          Telefono</h4>
        <span class="data">
          <input type="text" formControlName="Expert.phone">
        </span>
      </div>
      <div class="item data-col-10 center">
        <h4 class="title" (click)="navigateOrder('Expert.city')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Expert.city')"></i>
          Città</h4>
        <span class="data">
          <input type="text" formControlName="Expert.city">
        </span>
      </div>
      <div class="item data-col-10">
        <h4 class="title" (click)="navigateOrder('Vehicle.name')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Vehicle.name')"></i>
          Mezzo</h4>
        <span class="data">
          <select formControlName="Vehicle.id">
            <option value="">Tutti</option>
            <option *ngFor="let vehicle of vehicles" [value]="vehicle.id">
              {{vehicle.name}}
            </option>
          </select>
        </span>
      </div>

      <div class="item data-col-15 center">
        <h4 class="title">
          Team Leader
        </h4>
        <span class="data">
          <select formControlName="Expert.isTeamLeader">
            <option value="">Tutti</option>
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </span>
      </div>

      <div class="item data-col-15 center">
        <h4 class="title">
          <i class="sort-icon fas"></i>
          Attivo</h4>
        <span class="data">
          <select formControlName="User.active">
            <option value="">Tutti</option>
            <option value="1">Attivo</option>
            <option value="-1">Disattivo</option>
          </select>
        </span>
      </div>

      <div class="item nowrap">
        <h4 class="title hide-on-mobile">AZIONI</h4>
        <span class="data-row-left btn-container btn-container-actions">
          <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
            RICERCA <i class="fas fa-search"></i></button>
            <br/>
          <button class="btn vertical align-items-center" (click)="resetFilter();">
            RESET <i class="fas fa-times-circle"></i></button>
        </span>
      </div>
    </form>

    <div class="table-row-container row" *ngFor="let expert of experts; let i = index">
      <div class="item data-col-10" *ngIf="isTeamLeader">
        <h4 class="title">
          <i class="sort-icon fas"></i>
          ID</h4>
        <span class="data data-id"><a [routerLink]="['/expert', expert.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader) )}">{{ i+1 }}</a></span>
      </div>
      <div class="item data-col-10" *ngIf="!isTeamLeader">
        <h4 class="title" (click)="navigateOrder('Expert.id')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Expert.id')"></i>
          ID</h4>
        <span class="data data-id"><a [routerLink]="['/expert', expert.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader) )}">{{expert.id}}</a></span>
      </div>
      <div class="item data-col-15">
        <h4 class="title" (click)="navigateOrder('User.surname')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.surname')"></i>
          Cognome</h4>
        <span class="data"><a [routerLink]="['/expert', expert.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader))}">{{expert.user?.surname}}</a></span>
      </div>
      <div class="item data-col-15">
        <h4 class="title" (click)="navigateOrder('User.name')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.name')"></i>
          Nome</h4>
        <span class="data"><a [routerLink]="['/expert', expert.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader))}">{{expert.user?.name}}</a></span>
      </div>
      <div class="item data-col-15 center">
        <h4 class="title" (click)="navigateOrder('User.email')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.email')"></i>
          Email</h4>
        <span class="data"><a [routerLink]="['/expert', expert.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader))}">{{expert.user?.email}}</a></span>
      </div>
      <div class="item data-col-10 center">
        <h4 class="title" (click)="navigateOrder('Expert.phone')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Expert.phone')"></i>
          Telefono</h4>
        <span class="data"><a [routerLink]="['/expert', expert.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader))}">{{expert?.phone || "N/A"}}</a></span>
      </div>
      <div class="item data-col-10 center">
        <h4 class="title" (click)="navigateOrder('Expert.city')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Expert.city')"></i>
          Città</h4>
        <span class="data"><a [routerLink]="['/expert', expert.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader))}">{{expert.city || "N/A"}}</a></span>
      </div>
      <div class="item data-col-10">
        <h4 class="title" (click)="navigateOrder('Vehicle.name')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Vehicle.name')"></i>
          Mezzo</h4>
        <span class="data"><a [routerLink]="['/expert', expert.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader))}">{{expert.vehicles.length > 0 ? (getVehicleNames(expert.vehicles) | arrayJoin:", ") : "N/A" }}</a></span>
      </div>

      <div class="item data-col-10 center">
        <h4 class="title">
          Team Leader
        </h4>
        <span class="data">
          <a [routerLink]="['/expert', expert.id, 'edit']" [ngClass]="{'disabled-link': (groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader))}">{{ expert.isTeamLeader ? "Yes" : "No" }}</a>
        </span>
      </div>

      <div class="item data-col-10 center active">
        <h4 class="title">
          Attivo
        </h4>
        <span class="data">
          {{translateActive(expert.user?.active)}}
        </span>
      </div>

      <div class="item nowrap">
        <span class="data-row-left btn-container btn-container-actions">

          <button class="btn vertical align-items-center" [routerLink]="['/expert', expert.id, 'availability']" *ngIf="groups.includes('admin')">
            Availability
          </button>

          <button class="btn vertical align-items-center" [routerLink]="['/expert', expert.id, 'edit']" *ngIf="groups.includes('admin') || groups.includes('operation')">
            Modifica
          </button>

          <button class="btn vertical align-items-center" [routerLink]="['/expert/payments']" [queryParams]="{ expertId: expert.id }" *ngIf="(groups.includes('admin') || groups.includes('operation')) && expert.user.active === 1">
            Pagamenti
          </button>

          <button class="btn btn-red vertical align-items-center" (click)="$event.preventDefault(); delete(expert.id)" *ngIf="groups.includes('admin')">
            Elimina<i class="ml-10 far fa-trash-alt"></i>
          </button>

        </span>
      </div>
    </div>
  </div>
</section>
-->
